module.exports = __webpack_public_path__ + "media/src/assets/Images/MessageSendDark-472bf1e2f06260a8e3504cc8fd1d3ef2.svg";